import { Component, h } from '@stencil/core'
import { logWithBadge } from 'src/utils/logging'

import { getCSRFToken } from './csrf'

// This tag should only be used within forms that have a submit event.
@Component({
  tag: 'csrf-token',
})
export class CSRFToken {
  inputEl: HTMLInputElement

  componentDidRender() {
    // We are doing this because the token may have changed during the lifetime of the page.
    // If for some reason the form is not set, we still have our original token.
    if (this.inputEl?.form) {
      this.inputEl.form.addEventListener('submit', (_event) => {
        // On submit, update our token if we can
        const token = getCSRFToken()
        if (token && this.inputEl) {
          this.inputEl.setAttribute('value', token)
        }
      })
    } else {
      logWithBadge('CSRF Token', 'Failed to add listener on form')
    }
  }

  render() {
    const paramEl = document.querySelector<HTMLMetaElement>('[name="csrf-param"]')
    let name = 'authenticity_token'
    if (paramEl) {
      name = paramEl.content
    }

    return <input type='hidden' name={name} value={getCSRFToken()} ref={(el) => (this.inputEl = el)} />
  }
}
